import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { StyledTable } from "../../../Reusablecomponents/UITable/UITable";
import { Badge, Spin } from "antd";
import { CALL_API } from "../../../Common/api";
import ViewMore from "../../../Reusablecomponents/ViewMore";
import ReusablePagination from "../../../Reusablecomponents/ReusablePagination";
import { useSelector } from "react-redux";
import dayjs from "dayjs";

const Customstyle = styled.div`
  padding: 15px;
  .searchbar-style {
    width: 200px;
    border-radius: 12px;
  }
  .category-count-search {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .total {
    color: #5f6d8c;
    font-size: 16px;
    font-weight: 600;
    min-width: 110px;
    height: 19px;
    margin-left: 5px;
  }
  .recipients {
    max-width: 380px;
    white-space: normal;
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-word;
    display: flex;
    align-items: center;
  }
  .badge .ant-scroll-number {
    background-color: #ebf7ed !important;
    color: #5f6d8c !important;
    border-radius: 19px !important;
    min-width: 28px;
    height: 27px;
    line-height: 27px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    padding: 5px;
  }
`;

function EmailLog() {
  const [loading, setLoading] = useState(false);
  const [emailLog, setEmailLog] = useState(false);
  const [total, setTotal] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const userInfo = useSelector((state) => state?.authTracking?.userInfo);

  const handlePageChange = (page, pageSize) => {
    setCurrentPage(page);
    setPageSize(pageSize);
  };

  const handlePageSizeChange = (value) => {
    setPageSize(value);
    setCurrentPage(1);
  };

  const fetchEmailLog = async () => {
    setLoading(true);
    const { data } = await CALL_API(
      "GET",
      `email/getAll?mcid=${userInfo?.MCID}&page=${currentPage}&pageSize=${pageSize}`
    );
    setEmailLog(data?.emails || []);
    setTotal(data?.totalCount || 0);
    setLoading(false);
  };

  useEffect(() => {
    fetchEmailLog();
  }, [currentPage, pageSize]);

  const columns = [
    {
      title: "Subject",
      dataIndex: "SUB",
      key: "SUB",
      width: "12%",
    },
    {
      title: "Added on",
      dataIndex: "ADDED",
      key: "ADDED",
      width: "12%",
      render: (text) =>
        text ? (
          <div>
            {dayjs(text).format("Do MMM, YYYY")}
            <br />
            {dayjs(text).format("hh:mm A")}
          </div>
        ) : (
          "-"
        ),
    },
    {
      title: "Sent on",
      dataIndex: "SENT",
      key: "SENT",
      width: "12%",
      render: (text) =>
        text ? (
          <div>
            {dayjs(text).format("Do MMM, YYYY")}
            <br />
            {dayjs(text).format("hh:mm A")}
          </div>
        ) : (
          "-"
        ),
    },
    {
      title: "Recipients",
      dataIndex: "EMAILS",
      key: "EMAILS",
      width: "35%",
      // render: (text) => text || "-",
      render: (text) => {
        const recipientsList = text?.split(",")?.map((email) => email?.trim());
        return (
          <div className="recipients">
            {/* <span>{text}</span> */}
            <ViewMore value={text || "-"} count={50} />
            {/* <Badge className="badge" count={`+${recipientsList?.length}`} /> */}
          </div>
        );
      },
    },
    {
      title: "Error",
      dataIndex: "ERROR",
      key: "ERROR",
      width: "12%",
      render: (text) => text || "---",
    },

    {
      title: "Attempts",
      dataIndex: "ATTEMPTS",
      key: "ATTEMPTS",
      width: "12%",
    },
  ];
  return (
    <Customstyle>
      <div className="d-flex justify-content-between align-items-center">
        <div className="total">{total} Emails</div>
      </div>
      <Spin spinning={loading}>
        {emailLog.length > 0 && (
          <StyledTable
            className="mt-4"
            dataSource={emailLog}
            columns={columns}
            pagination={false}
            style={{
              cursor: "default",
            }}
          />
        )}
        <ReusablePagination
          pageSize={pageSize}
          handlePageSizeChange={handlePageSizeChange}
          currentPage={currentPage}
          total={total}
          handlePageChange={handlePageChange}
        />
      </Spin>
    </Customstyle>
  );
}

export default EmailLog;
